module.exports = __webpack_public_path__ + "static/media/13_l_stopka_6.67_85.28.02b552d2.png";